// extracted by mini-css-extract-plugin
module.exports = {"load-shedding-J":"J_load-shedding-J__5w0Ow"};